export default "__VITE_ASSET__f3303450__"